import { type AssetType } from "@doitintl/cmp-models";
import { Avatar } from "@mui/material";

import AWSIconWhite from "../../../../../assets/amazon-web-services-logo-white.png";
import AWSIcon from "../../../../../assets/amazon-web-services-new-wide.png";
import AzureIcon from "../../../../../assets/azure-logo.svg";
import GSuiteIcon from "../../../../../assets/g-suite.png";
import GoogleCloudIcon from "../../../../../assets/google-cloud.png";
import Office365Icon from "../../../../../assets/office-365.png";
import { useDarkThemeCheck } from "../../../../hooks/useDarkThemeCheck";

const darkThemeIcons: Partial<Record<AssetType, string>> = {
  "amazon-web-services": AWSIconWhite,
  "g-suite": GSuiteIcon,
  "google-cloud": GoogleCloudIcon,
  "google-cloud-project": GoogleCloudIcon,
  "microsoft-azure": AzureIcon,
  "office-365": Office365Icon,
};

const lightThemeIcons: Partial<Record<AssetType, string>> = {
  "amazon-web-services": AWSIcon,
  "g-suite": GSuiteIcon,
  "google-cloud": GoogleCloudIcon,
  "google-cloud-project": GoogleCloudIcon,
  "microsoft-azure": AzureIcon,
  "office-365": Office365Icon,
};

export const AssetLogo = ({ assetType }: { assetType: AssetType }) => {
  const isDark = useDarkThemeCheck();
  const logo = isDark ? darkThemeIcons[assetType] : lightThemeIcons[assetType];
  return (
    <Avatar
      key={logo}
      src={logo}
      variant="square"
      sx={{ width: 24, height: 24 }}
      slotProps={{
        img: { sx: { objectFit: "contain" } },
      }}
    />
  );
};
